import layer_element from "./element/layer_element";
import JsUtil from "./func/util";

const reward_btn = document.querySelector(".p-btn__reward");
const login_btn = document.querySelector(".p-btn__login");
const facebook_btn = document.querySelector(".p-btn__facebook");
const twitter_btn = document.querySelector(".p-btn__twitter");
const url_btn = document.querySelector(".p-btn__url");
const layer_list = [
    {
        el: '#layer-awards-my',
        buttons: '.p-btn__awards-my'
    },
    {
        el: '#layer-awards-platinum',
        buttons: '.p-btn__awards-platinum--info'
    },
    {
        el: '#layer-special',
        buttons: '.p-btn__special'
    },
    {
        el: '#layer-fortress',
        buttons: '.p-btn__fortress'
    },
];

/* 각종 유틸 메소드를 가진 util 인스턴스. */
window.jsUtil = new JsUtil();
/* 레이어 */
let make_layer = layer_list.map(ele=>{
    let table = document.querySelector(ele['el']).querySelector('table');
    if(table)table.outerHTML = layer_element[ele['el']];

    return ele['buttons'] && promokit.layer(ele);
});

/* 페이지 */
let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        home:true,
        event:true,
        update:false,
        sns:true,
        theme:'black'
    },
    caution:{
        template:
        `<ol>
            <li>라이브 서버 고객 및 제재 계정은 이벤트 참여가 불가능합니다.</li>
            <li>운영정책 어뷰징에 제재된 이력이 있는 계정은 일부 항목의 기록이 노출되지 않을 수 있습니다.</li>
            <li>데바의 공훈 영역의 공훈 훈장은 이미지만 표기되며, 실제 공훈 훈장이 지급되지 않습니다.</li>
            <li>해당 이벤트를 통해 획득한 쿠폰은 발급일로부터 30일간 사용할 수 있습니다.</li>
            <li>해당 이벤트를 통해 지급되는 쿠폰은 신 서버 마르쿠탄에서 사용할 수 없습니다.</li> 
            <li>쿠폰 사용 후 인게임 수령에 주의하시길 바라며, 잘못 사용 시 복구가 불가능합니다.</li>
            <li>해당 이벤트에서 배포한 모든 아이템은 거래 및 판매 대행이 불가능합니다.</li>
            <li>스페셜 데바로 선정된 각 서버별 1등의 캐릭터는 최대 횟수를 달성한 시점의 캐릭터명이 노출됩니다.</li>
            <li>스페셜 데바로 선정된 캐릭터가 서버 이전, 캐릭터명 변경 등으로 검색되지 않을 수 있습니다.</li>
            <li>[이벤트]가 포함된 아이템은 이벤트 종료 후 정해진 시점에 삭제될 수 있습니다.</li>
        </ol>`
    }
});

/* 로그인 */
login_btn && login_btn.addEventListener('click',function(e){
    promokit.login();
});


/* 공유하기 */
facebook_btn.addEventListener('click',function(e){
    e.preventDefault();
    promokit.share({
        target: 'facebook'
    });
});
twitter_btn.addEventListener('click',function(e){
    e.preventDefault();
    promokit.share({
        target: 'twitter'
    });
});

url_btn.addEventListener('click',function(e){
    e.preventDefault();
    promokit.share({
        target: 'url'
    });
});



// WEBPACK FOOTER //
// ./src/js/index.js